<template>
<div class="modal-container-height">

</div>
</template>

<script>
import SubmitPaymentModal from "@/components/Payments/SubmitPaymentModal";
import PaymentFormsMixin from "@/mixins/PaymentFormsMixin";

export default {
  name: "ShowSubmitPaymentModal",
  created() {
    this.launchSubmitPaymentModal()
  },
  mixins: [PaymentFormsMixin],
  beforeDestroy() {
    this.$modal.hide('SubmitPaymentModal')
    document.documentElement.style.overflow = "auto";
  },
  methods: {
    launchSubmitPaymentModal() {
      document.documentElement.style.overflow = "hidden";
      this.$modal.show(
          SubmitPaymentModal,
          {},
          {
            name: 'SubmitPaymentModal',
            adaptive: true,
            width: 1000,
            height: "auto",
            scrollable: false,
            class: 'submit-payment-modal'
          }, {
          closed: (route) => {
            if(route && typeof(route) === 'string') {
              /*
                the modal is launched from breadcrumb btns as well as from guides tile.
                User needs to be sent back to the original page they started from.
                On close, if we receive 'back' from SubmitPaymentModal, we route them to -1 page.
              */
              if(route === 'back') {
                if (window.history.length > 2) {
                  this.$router.go(-1);
                } else {
                  this.$router.push("/").then(() => {});
                }
              } else {
                /* eslint-disable no-console */
                this.$router.push({name: route}).catch((ex) => { if(ex.name !== 'NavigationDuplicated') { console.error(ex) }})
              }
            } else {
              /* eslint-disable no-console */
              this.$router.push({path: '/'}).catch((ex) => { if(ex.name !== 'NavigationDuplicated') { console.error(ex) }})
            }
          },
        }
      );
    },
  }
}
</script>

<style scoped>
.modal-container-height {
  height: 100vh;
}
</style>